<style>
.el-notification__group.is-with-icon {
    word-break: break-all;
}
.hb-tag--checkbox-container label.el-checkbox {
    height: 29px;
    width: 90%;
}
.hb-tag--checkbox-container .el-checkbox__label {
    text-overflow: ellipsis;
    width: 100%;
    vertical-align: middle;
    overflow: hidden;
}
.el-collapse-item__header {
    height: auto !important;
    min-height: 48px;
}
</style>
<style scoped>
.hb-amp--container .el-button {
    margin: 0 1px;
}
.el-button--info {
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.04) !important;
    padding: 10px;
    background-color: white;
    color: black;
}
.el-button--info:hover {
    box-shadow: 0 1px 40px rgba(0, 0, 0, 0.05);
    /*box-shadow: 0 1px 40px rgba(0,0,0,.9);*/
    border: 1px solid rgba(0, 0, 0, 0.04) !important;
    padding: 10px;
    background-color: white;
    color: black;
}
.content-wrapper .content {
    padding-top: 95px;
}
.el-select {
    display: block;
}
.recentlyClosed {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}
.opened {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}
h5 {
    line-height: 2;
}
.el-collapse-item__header {
    height: auto !important;
}
.el-collapse-item__header .hbtag--dimension h5 {
    /* width: 215px; */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

div.el-collapse-item__wrap {
    display: inline;
}
.no-bidders {
    text-align: center;
    color: red;
}
.bidder-params-box {
    border: 2px solid #3c8dbc;
}

.params--text {
    font-size: 14px;
    display: inline-block;
    vertical-align: text-top;
}

.param-copy--btn {
    display: inline-block;
    vertical-align: text-bottom;
}

.modify--btn {
    margin-right: 14px;
}

.collapse--item {
    margin-bottom: 10px;
    padding-left: 10px;
    padding-right: 10px;
}

.collapse--item:first-child {
    margin-top: 10px;
}
.param-set-input {
    display: inline-block;
    /*width: 45%;*/
}
</style>
<template>
    <div class="content-wrapper">
        <section class="content">
            <div class="box">
                <div class="box-header with-border">
                    <h3 class="box-title">Select Param set for {{ is_amp ? 'AMP' : 'DISPLAY' }} ad units</h3>
                    <div>
                        <el-input
                            style="display: inline-block; width: 80%; margin: 0 0 10px 10px"
                            data-vv-delay="1000"
                            name="searchString"
                            type="text"
                            placeholder="search HB Unit by HB Unit tag (type and enter)"
                            v-model="searchString"
                            @keyup.enter.native="filterHbAdUnit()"
                        ></el-input>
                        <el-tooltip content="clearSearch" placement="top">
                            <el-button
                                type="danger"
                                icon="el-icon-close"
                                @click="clearSearch()"
                                style="display: inline-block"
                            >
                                <!-- <i class="el-icon-close"></i> -->
                            </el-button>
                        </el-tooltip>
                        <div style="overflow: auto">
                            <div class="col-md-4" style="padding-left: 10px">
                                <el-select
                                    v-model="selectedDimensions"
                                    class=""
                                    multiple
                                    placeholder="Select Dimensions"
                                    @change="filterDimension()"
                                    name="Dimensions"
                                >
                                    <el-option
                                        v-for="(dimension, index) in allDimensionsSearch"
                                        :key="index"
                                        :label="`${dimension.width}X${dimension.height}`"
                                        :value="dimension.id"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="col-md-4">
                                <el-input
                                    style="display: inline-block"
                                    data-vv-delay="1000"
                                    name="selectedNetworkCode"
                                    type="text"
                                    placeholder="Search Parent Network Code"
                                    v-model="selectedNetworkCode"
                                    @keyup.enter.native="filterHbAdUnit()"
                                ></el-input>
                            </div>

                            <div class="col-md-4">
                                <el-input
                                    style="display: inline-block"
                                    data-vv-delay="1000"
                                    name="selectedChildDfpNetworkCode"
                                    type="text"
                                    placeholder="Search Child Network Code"
                                    v-model="selectedChildDfpNetworkCode"
                                    @keyup.enter.native="filterHbAdUnit()"
                                ></el-input>
                            </div>
                            <div>
                                <el-checkbox
                                    class="col-md-4"
                                    style="padding-left: 10px; width: 100%; padding-top: 8px"
                                    v-model="searchNetworkOverride"
                                    >Search Network Override?</el-checkbox
                                >
                            </div>
                        </div>
                    </div>

                    <el-dialog
                        class="element-promt"
                        title="Meta Tags"
                        :visible.sync="pubInsdialogVisible"
                        width="30%"
                        :before-close="handleClose"
                    >
                        <el-input type="textarea" :rows="10" v-model="pubInstructions"></el-input>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="pubInsdialogVisible = false">Cancel</el-button>
                            <el-button type="primary" @click="pubInsdialogVisible = false">Confirm</el-button>
                        </span>
                    </el-dialog>

                    <el-button
                        v-show="is_amp"
                        type="text"
                        @click="pubInsdialogVisible = true"
                        class="el-button el-button--info pull-right"
                        v-clipboard:copy="pubInstructions"
                    >
                        <svg
                            aria-hidden="true"
                            width="16px"
                            height="16px"
                            data-prefix="fal"
                            data-icon="copy"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                            class="svg-inline--fa fa-copy fa-w-14"
                            style="font-size: 48px"
                        >
                            <path
                                fill="currentColor"
                                d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM352 32.491a15.88 15.88 0 0 1 7.431 4.195l51.882 51.883A15.885 15.885 0 0 1 415.508 96H352V32.491zM288 464c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V144c0-8.822 7.178-16 16-16h80v240c0 26.51 21.49 48 48 48h112v48zm128-96c0 8.822-7.178 16-16 16H176c-8.822 0-16-7.178-16-16V48c0-8.822 7.178-16 16-16h144v72c0 13.2 10.8 24 24 24h72v240z"
                                class=""
                            ></path></svg
                        >&nbsp; Copy Publisher Instructions
                    </el-button>
                </div>
                <div class="box-body">
                    <div class="clearfix">
                        <router-link
                            :to="
                                is_amp
                                    ? `/admin/publisher/${pubUid}/domain/${domId}/create-hb-tag-amp/`
                                    : `/admin/publisher/${pubUid}/domain/${domId}/create-hb-tag/`
                            "
                            class="el-button el-button--info pull-right"
                        >
                            <i class="el-icon-plus el-icon-left"></i>
                            Create {{ is_amp ? `AMP` : `display` }} HB tag
                        </router-link>
                        <el-button
                            type="info"
                            v-if="domainMcmEnabled"
                            @click="bulkmigrateEnabled = !bulkmigrateEnabled"
                            class="pull-right"
                            >Bulk Migrate</el-button
                        >

                        <!-- <router-link v-if="!is_amp" :to="(is_amp)? `/admin/publisher/${pubUid}/domain/${domId}/create-hb-tag-amp/` : `/admin/publisher/${pubUid}/domain/${domId}/hb-tags-dimensions/`" class="el-button el-button--info">
							<i class="el-icon-plus el-icon-left"></i>
							Input dimensionwise bidder params
						</router-link> -->
                    </div>

                    <div v-if="domainMcmEnabled && bulkmigrateEnabled" style="">
                        <h4 class="box-title">Bulk Migration</h4>
                        <div style="width: 80%; margin: 0px 0px 10px 10px">
                            <h5>Is MCM Enabled?</h5>
                            <el-switch
                                active-text=""
                                inactive-text=""
                                active-color="#13ce66"
                                inactive-color="#ff4949"
                                v-model="mcm_enabled"
                                >Is sticky Unit?</el-switch
                            >
                        </div>
                        <div class="row" v-if="mcm_enabled && domainMcmEnabled" style="margin: 0px 0px 8px -6px">
                            <div class="col-md-3" style="">
                                <h5>Select MCM Delegation Type:</h5>
                                <el-select
                                    v-model="account_type"
                                    placeholder="Select MCM Delegation Type"
                                    @change="filterNetworkList"
                                >
                                    <el-option
                                        v-for="(mcm_account_type, id) in mcmAccountType"
                                        :data-id="id"
                                        :label="mcm_account_type.account_type.replaceAll('_', ' ')"
                                        :value="mcm_account_type.account_type"
                                        :key="id"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="col-md-3">
                                <h5>Select Child DFP Network</h5>
                                <el-select
                                    :disabled="account_type == null"
                                    v-model="child_dfp_network"
                                    filterable
                                    placeholder="Select Child DFP Network"
                                >
                                    <el-option
                                        v-for="network in filteredAccountList"
                                        :key="network.id"
                                        :label="`${network.child_network_code + ' : ' + network.name}`"
                                        :value="network.child_network_code"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="col-md-3">
                                <h5>Add DFP Parent Adunit Id</h5>
                                <el-input
                                    :disabled="account_type == null && child_dfp_network == null"
                                    placeholder="Add DFP Parent Adunit Id"
                                    v-model="dfp_parent_ad_unit_id"
                                ></el-input>
                            </div>
                            <div class="col-md-3">
                                <h5>Add DFP Parent Adunit Path</h5>
                                <el-input
                                    :disabled="
                                        account_type == null || child_dfp_network == null || dfp_parent_ad_unit_id == 0
                                    "
                                    placeholder="Add DFP Parent Adunit Path"
                                    v-model="dfp_parent_ad_unit_path"
                                >
                                </el-input>
                            </div>

                            <div class="col-md-6" style="margin-top: 10px" v-if="account_type != null">
                                <el-button
                                    type="success"
                                    @click="finalList(true)"
                                    style="display: inline-block"
                                    :disabled="dfp_parent_ad_unit_path == null || dfp_parent_ad_unit_path == ''"
                                >
                                    Migrate all
                                </el-button>
                                <el-button
                                    type="success"
                                    @click="finalList(false)"
                                    style="display: inline-block"
                                    :disabled="dfp_parent_ad_unit_path == null || dfp_parent_ad_unit_path == ''"
                                >
                                    Migrate selected
                                </el-button>
                            </div>
                        </div>
                    </div>
                    <div style="padding-top: 30px" v-loading="loading">
                        <div class="text-center" v-if="hb_tags.length == 0">
                            <h5>No {{ is_amp ? 'AMP' : 'display' }} HB tags. Create a tag by clicking create HB tag</h5>
                        </div>

                        <el-collapse v-model="activeNames" @change="handleChange" accordion>
                            <el-collapse-item
                                v-bind:class="{
                                    recentlyClosed: recentlyClosed == hb_tag.id,
                                    opened: activeNames == hb_tag.id,
                                }"
                                v-for="hb_tag in hb_tags"
                                :title="hb_tag.id + ''"
                                :name="hb_tag.id"
                                class="collapse--item"
                            >
                                <template slot="title">
                                    <div style="width: 100%">
                                        <div style="width: 36%; float: left; position: relative">
                                            <el-checkbox-group
                                                v-model="checkedHbTags"
                                                @change="handleCheckedHbTagsChange"
                                                :disabled="hb_tag.publisher_dfp_unit"
                                                v-if="domainMcmEnabled && bulkmigrateEnabled"
                                                class="hb-tag--checkbox-container"
                                            >
                                                <el-checkbox :label="hb_tag.id" :key="hb_tag.id">
                                                    <label
                                                        :title="getAdunitPath(hb_tag)"
                                                        style="
                                                            font-weight: 900;
                                                            white-space: nowrap;
                                                            text-overflow: ellipsis;
                                                        "
                                                        >{{ getAdunitPath(hb_tag) }}
														
														
														</label
                                                    >
                                                </el-checkbox>
                                            </el-checkbox-group>
                                            <div
											
                                                v-else:title="getAdunitPath(hb_tag)"
												
                                                style="
                                                    font-weight: 900;
                                                    white-space: nowrap;
                                                    text-overflow: ellipsis;
                                                    overflow: hidden;
                                                "
                                            >
											
                                                {{ getAdunitPath(hb_tag) }}
												
                                            </div>
                                        </div>
                                        <div
                                            style="width: 30%; float: left; position: relative"
                                            class="hbtag--dimension"
                                        >
                                            <h5 style="/*padding: 20px 0px;*/">
                                                <span
                                                    style="
													    width:100%;
                                                        position: relative;
                                                        background-color: aquamarine;
                                                        padding: 3px;
                                                        border-radius: 10px;
                                                        margin-right: 10px;
                                                    "
                                                    v-for="dim in getDimension(hb_tag.dimensions)"
                                                >
                                                    {{ dim }}
                                                    <i
                                                        style="
                                                            /*position: absolute;left: 0px;right: 0px;text-align: center;top: -12px;*/
                                                        "
                                                        class="el-icon-success"
                                                        v-if="
                                                            bidderParamsForm2.formData[hb_tag.id][dim]['param_set'] !=
                                                            undefined
                                                        "
                                                    ></i>
                                                </span>
                                            </h5>
                                        </div>
                                        <div
                                            style="width: 30%; float: left; position: relative; display: flex"
                                            :class="is_amp ? 'hb-amp--container' : ''"
                                        >
                                            <el-button
                                                v-if="is_amp"
                                                type="text"
                                                class="el-button el-button--info pull-right"
                                                v-clipboard:copy="copyAmpTag(hb_tag)"
                                                @click.stop=""
                                                v-clipboard:success="ampTagCopied"
                                            >
                                                <i class="el-icon"></i>
                                                Copy AMP tag
                                            </el-button>

                                            <el-button
                                                v-if="is_amp"
                                                type="text"
                                                class="el-button el-button--info pull-right"
                                                v-clipboard:copy="copyTagId(hb_tag)"
                                                @click.stop=""
                                                v-clipboard:success="tagIdCopied"
                                            >
                                                <i class="el-icon"></i>
                                                Copy Tag ID
                                            </el-button>

                                            <!-- <el-button v-if="!is_amp" type="text" class="el-button el-button--info pull-right" v-clipboard:copy="copyAmpTag(hb_tag)" @click.stop="" v-clipboard:success="ampTagCopied">
												<i class="el-icon"></i>
												Copy HB tag
											</el-button> -->

                                            <router-link
                                                :to="{
                                                    path: is_amp
                                                        ? `/admin/publisher/${pubUid}/domain/${domId}/modify-hb-tag-amp/${hb_tag.id}/?page=${currentPage}`
                                                        : `/admin/publisher/${pubUid}/domain/${domId}/modify-hb-tag/${hb_tag.id}/?page=${currentPage}`,
                                                }"
                                                class="el-button el-button--info pull-right modify--btn"
											    
                                            >
                                                <i class="el-icon"></i>
                                                Modify Tag
                                            </router-link>
	
                                            <router-link
                                                :to="{
                                                    path: is_amp
                                                        ? `/admin/publisher/${pubUid}/domain/${domId}/create-hb-tag-amp/?hb_id=${hb_tag.id}&page=${currentPage}`
                                                        : `/admin/publisher/${pubUid}/domain/${domId}/create-hb-tag/?hb_id=${hb_tag.id}&page=${currentPage}`,
                                                }"
                                                class="el-button el-button--info modify--btn"
												
                                            >
                                                <i class="el-icon"></i>
                                                Duplicate Tag
                                            </router-link>
											
                                        </div>
										<div style="width:100%;display:inline-block;">
										<el-dropdown style="display:inline;" trigger="click" class="see-usage" @command="OpenHbAdUnitsUsage">
                                    <span class="el-dropdown-link">
                                        See usage in bucket<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item
                                            :command="{
                                                name: bucket_name,
                                                bucket_id: bucket.id,
                                                hb_tag_id: hb_tag.id,
                                            }"
                                            v-for="bucket in domain_details.buckets"
                                            :key="bucket.id"
                                        >
                                            <span>{{ bucket.name }}</span>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
								</div>
                                    </div>
                                </template>
                                <div style="height: 50px; margin: 10px 0px" v-for="(dim, index) in hb_tag.dimensions">
                                    <el-row :gutter="20">
                                        <el-col :span="8">
                                            <div class="grid-content">
                                                <h5 style="margin: 0px; line-height: 50px; display: inline-block">
                                                    Select Param set for {{ `${dim.width}X${dim.height}` }}
                                                </h5>
                                            </div>
                                        </el-col>
                                        <el-col :span="8" style="height: 50px">
                                            <div
                                                class="grid-content"
                                                style="top: 50%; position: relative; transform: translateY(-50%)"
                                            >
                                                <el-select
                                                    class="param-set-input select-input"
                                                    v-model="
                                                        bidderParamsForm2.formData[hb_tag.id][
                                                            `${dim.width}X${dim.height}`
                                                        ]['param_set']
                                                    "
                                                    @change="updateHbTag(hb_tag, dim)"
                                                    filterable
                                                    placeholder="Select param set"
                                                >
                                                    <el-option
                                                        v-for="param_set in getParamSetsForDim(dim.id)"
                                                        :key="param_set.id"
                                                        :label="param_set.alias"
                                                        :value="param_set.id"
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </div>
                                        </el-col>
                                        <el-col :span="8" style="height: 50px">
                                            <div
                                                class="grid-content"
                                                style="top: 50%; position: relative; transform: translateY(-50%)"
                                            >
                                                <div style="margin: 0px; display: inline-block">
                                                    <el-button
                                                        :disabled="
                                                            bidderParamsForm2.formData[hb_tag.id][
                                                                `${dim.width}X${dim.height}`
                                                            ]['param_set'] == undefined
                                                        "
                                                        type="primary"
                                                        @click="updateHbTag(hb_tag, dim)"
                                                    >
                                                        Update Tag
                                                    </el-button>
                                                </div>
                                            </div>
                                        </el-col>
                                    </el-row>
                                    <!-- <h5 style="margin: 0px;line-height: 50px;width: 35%;display: inline-block;">
										Select Param set for {{ `${dim.width}X${dim.height}` }}
									</h5>

									<el-select class = "param-set-input select-input" v-model="bidderParamsForm2.formData[hb_tag.id][`${dim.width}X${dim.height}`]['param_set']" filterable placeholder="Select param set">
										<el-option
										  v-for="param_set in getParamSetsForDim(dim.id)"
										  :key="param_set.id"
										  :label="param_set.alias"
										  :value="param_set.id">
										</el-option>
									</el-select>
									<div style="margin: 0px;width: 15%;display: inline-block;">
										<el-button type="primary" class="col-md-2" @click="updateHbTag(hb_tag.id, dim)">
											Update Tag
										</el-button>
									</div> -->
                                </div>
                            </el-collapse-item>
                        </el-collapse>
                        <el-pagination
                            style="text-align: center; margin-top: 30px"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :total="total_pages"
                            layout="sizes, prev, pager, next"
                            :page-size="offset"
                        >
                        </el-pagination>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    data() {
        return {
            currentPage: 1,
            offset: 10,
            total_pages: 0,
            dfp_parent_ad_unit_path: null,
            bulkmigrateEnabled: false,
            dfp_parent_ad_unit_id: 0,
            searchNetworkOverride: false,
            checkedHbTags: [],
            filteredAccountList: [],
            account_type: null,
            mcm_enabled: false,
            child_dfp_network: null,
            mcmAccountType: [],
            childDfpAccounts: [],
            domainMcmEnabled: false,
            selectedChildDfpNetworkCode: '',
            selectedNetworkCode: '',
            selectedDimensions: [],
            allDimensionsSearch: [],
            issearch: false,
            searchString: '',
            pubUid: undefined,
            activeNames: undefined,
            activeNames2: undefined,
            recentlyClosed: '',
            domId: undefined,
            domain_details: undefined,
            hb_tags: [],
            all_amp_hb_tags: [],
            dimensions: [],
            bidders: [],
            name: '',
            bidderParamsForm: {
                formData: {},
            },
            bidderParamsForm2: {},
            loading: true,
            dimArr: [],
            bidderCopyParamsData: {},
            pubInsdialogVisible: false,
            param_sets: [],
            pubInstructions: `Document header

<!DOCTYPE HTML>
<html amp>
<head>
<meta charset="utf-8">
<title>Widgets Magazine</title>
<link rel="canonical" href="$REGULAR_HTML_URL" />
<meta name="viewport" content="width=device-width,minimum-scale=1,initial-scale=1">
<style amp-boilerplate>body{-webkit-animation:-amp-start 8s steps(1,end) 0s 1 normal both;-moz-animation:-amp-start 8s steps(1,end) 0s 1 normal both;-ms-animation:-amp-start 8s steps(1,end) 0s 1 normal both;animation:-amp-start 8s steps(1,end) 0s 1 normal both}@-webkit-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@-moz-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@-ms-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@-o-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}<\/style><noscript><style amp-boilerplate>body{-webkit-animation:none;-moz-animation:none;-ms-animation:none;animation:none}<\/style></noscript>
<script async src="https://cdn.ampproject.org/v0.js"><\/script>
<script async custom-element="amp-ad" src="https://cdn.ampproject.org/v0/amp-ad-0.1.js"><\/script>
<script async custom-element="amp-sticky-ad" src="https://cdn.ampproject.org/v0/amp-sticky-ad-1.0.js"><\/script>
<script async custom-element="amp-iframe" src="https://cdn.ampproject.org/v0/amp-iframe-0.1.js"><\/script>
<script async custom-element="amp-fx-flying-carpet" src="https://cdn.ampproject.org/v0/amp-fx-flying-carpet-0.1.js"><\/script>
</head>


On every page, the above ad tags are added, we need to include the following tag inside the body tag:
 <amp-iframe layout="fixed-height" width="auto" title="User Sync" height="1" sandbox="allow-scripts allow-same-origin" frameborder="0" src="https://b2cdn.automatad.com/geo/amp_user_sync/load-cookies.html">
  <amp-img layout="fill" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" placeholder width="1" height="1"></amp-img>
 </amp-iframe>`,
        };
    },
    props: {
        is_amp: Boolean,
    },
    watch: {
        $route(to, from) {
            console.warn(`route changed from ${from} to ${to}`);
            this.initialize(this.currentPage);
        },
    },
    created: function () {
        if (this.$route.query.page && !isNaN(parseInt(this.$route.query.page)))
            this.currentPage = parseInt(this.$route.query.page);
        console.log(this.currentPage);
        this.initialize(this.currentPage);
        this.getSizeForSearchDropdown();

        axios.get(BASE_URL + 'v1/mcm-account-list/').then((res) => {
            this.mcmAccountType = res.data;
        });
        axios.get(BASE_URL + 'v1/child-dfp-network-list/').then((res) => {
            this.childDfpAccounts = res.data;
        });
    },
    methods: {
        handleCheckedHbTagsChange() {
            console.log('handleCheckedHbTagsChange', this.checkedHbTags);
        },
        finalList(isAll) {
            // if(this.account_type == "MANAGE_ACCOUNT" && this.dfp_parent_ad_unit_id == 0){
            // 	this.$notify({
            // 				title: 'Error',
            // 				message: "please add dfp parent ad unit id",
            // 				type: 'Error'
            // 		});
            // 	return;
            // }
            var finalList = [];
            var hb_tags_withoutPubUnit = [];
            hb_tags_withoutPubUnit = this.hb_tags.filter((k) => {
                if (!k.publisher_dfp_unit) return k;
            });
            if (isAll == true) {
                this.$confirm('<label">This will migrate all the adunit. Continue?</label>', 'Warning', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning',
                    center: false,
                })
                    .then(() => {
                        if (hb_tags_withoutPubUnit && hb_tags_withoutPubUnit.length != 0) {
                            finalList = hb_tags_withoutPubUnit;
                        }
                        this.migrateAll(finalList);
                    })
                    .catch(() => {
                        this.$notify({
                            title: 'Info',
                            message: 'Migrate all adunit Canceled!',
                            type: 'info',
                        });
                    });
            } else {
                if (this.checkedHbTags.length == 0) {
                    this.$notify({
                        title: 'Error',
                        message: 'please select adunit',
                        type: 'Error',
                    });
                    return;
                }
                finalList = hb_tags_withoutPubUnit.filter((k) => {
                    if (this.checkedHbTags.includes(k.id)) return k;
                });
                this.migrateAll(finalList, isAll);
            }
        },
        migrateAll(finalList, isAll) {
            console.log('finalList', finalList);
            console.log('finalList', finalList.length);
            var reqObj = [];
            var singleObj = {};
            for (var i = 0; i < finalList.length; i++) {
                singleObj = {
                    ['enabled']: finalList[i].enabled,
                    ['dimensions']: finalList[i].dimensions.map((i) => {
                        return i.id;
                    }),
                    ['domain_id']: finalList[i].domain_id,
                    ['floor']: finalList[i].floor,
                    ['pub_dfp_unit_path']: finalList[i].pub_dfp_unit_path,
                    ['isPubUnit']: this.isPubUnit,
                    ['amp_currency']: finalList[i].amp_currency_id,
                    ['network_code']:
                        finalList[i].network_override != this.domain_details.dfp_network.network_code
                            ? finalList[i].network_override
                            : null,
                    ['name']: finalList[i].pub_dfp_unit_path,
                    ['post_fix']: finalList[i].post_fix,
                    ['current_dfp_network']: this.domain_details.dfp_network.network_code,
                    ['child_network_override']: this.child_dfp_network,
                    ['mcm_account_switch']: this.account_type,
                    ['hb_tag_id']: finalList[i].id,
                    ['is_amp_sticky']: finalList[i].is_amp_sticky,
                    ['is_amp']: finalList[i].is_amp,
                    ['dfp_parent_ad_unit_id']: this.dfp_parent_ad_unit_id,
                };
                if (finalList[i].hasOwnProperty('name') && finalList[i].name) {
                    singleObj.name = finalList[i].name;
                    if (!this.isPubUnit) {
                        singleObj.dfp_parent_ad_unit_path = this.dfp_parent_ad_unit_path;
                    } else {
                        singleObj.dfp_parent_ad_unit_path = null;
                    }
                } else {
                    if (!this.isPubUnit) {
                        console.log('dfp_parent_ad_unit_path', this.dfp_parent_ad_unit_path);
                        singleObj.dfp_parent_ad_unit_path = this.dfp_parent_ad_unit_path;
                        singleObj.name =
                            'ATD_' + this.getDimension(finalList[i].dimensions) + '_' + finalList[i].post_fix;
                    } else {
                        singleObj.dfp_parent_ad_unit_path = null;
                        singleObj.name = finalList[i].pub_dfp_unit_path;
                    }
                }

                reqObj.push(singleObj);
            }
            console.log('single obj', singleObj);

            // reqObj.push(singleObj);
            console.log('req obj', reqObj);
            console.log('this.account_type', this.account_type, 'child_dfp_network', this.child_dfp_network);

            var url = BASE_URL + `v1/migrate-hb-ad-units/${this.domId}`;
            axios.put(url, reqObj).then((res) => {
                console.log('res', res);
                var msg = '';
                if (res.data && res.data.status == false) {
                    this.$notify({
                        title: 'Error',
                        message: res.data['exising ad units'],
                        type: 'error',
                        duration: 15000,
                    });
                } else {
                    if (isAll) {
                        msg = 'Successfully Migrated All Tags';
                    } else {
                        msg = 'Successfully Migrate selected Tags';
                    }
                    this.$notify({
                        title: 'Success',
                        message: msg,
                        type: 'success',
                    });
                }

                this.checkedHbTags = [];
                this.initialize(this.currentPage);
            });
        },
        filterNetworkList() {
            if (this.account_type) {
                console.log('calling filterNetworkList');
                var selectedAccount = this.account_type;
                // console.log("calling selectedAccount" ,selectedAccount);

                this.filteredAccountList = this.childDfpAccounts.filter((k) => {
                    return k.delegation_type == selectedAccount;
                });
                // console.log("calling filteredAccountList" ,this.filteredAccountList);
                this.child_dfp_network = null;
                // console.log("calling child_dfp_network",this.child_dfp_network);
            }
        },
        getAdunitPath(k) {
            // console.log("^^^^k",k);
            var hbAmp = k.is_amp;
            var domainNetowrkCode = this.domain_details.dfp_network.network_code;
            var domainParentCode = '';
            if (k.mcm_account_switch == null) {
                domainParentCode =
                    hbAmp == false
                        ? this.domain_details.parent_ad_unit_code
                        : this.domain_details.amp_parent_ad_unit_code;
            } else {
                if (k.mcm_account_switch == 'MANAGE_ACCOUNT') {
                    domainParentCode = k.dfp_parent_ad_unit_path;
                } else {
                    if (k.dfp_parent_ad_unit_path != 0) {
                        domainParentCode = k.dfp_parent_ad_unit_path;
                    } else {
                        domainParentCode =
                            hbAmp == false
                                ? this.domain_details.parent_ad_unit_code
                                : this.domain_details.amp_parent_ad_unit_code;
                    }
                }
            }

            this.domainMcmEnabled = this.domain_details.mcm_enable;
            var domainMcmType = this.domain_details.mcm
                ? this.domain_details.mcm.account_type
                : this.domain_details.mcm;
            var domainMcmChild = this.domain_details.child_dfp_network
                ? this.domain_details.child_dfp_network.child_network_code
                : this.domain_details.child_dfp_network;
            var hbAccountType = k.mcm_account_switch;
            var hbOverridenChildNetwork = k.child_network_override;
            var adunitCode = k.dfp_ad_unit_code;
            var hbNetworkOverride = k.network_override;
            var isPubUnit = k.publisher_dfp_unit;
            var ishbNtwrkOverriden = k.network_override == null ? false : true;
            var current_dfp_network = k.current_dfp_network;

            if (isPubUnit == true) {
                if (hbAccountType) {
                    if (hbAccountType == 'MANAGE_ACCOUNT') {
                        return `${hbOverridenChildNetwork}/${adunitCode}`;
                    } else {
                        // return `${domainNetowrkCode},${hbOverridenChildNetwork}/${adunitCode}`
                        return `${current_dfp_network},${hbOverridenChildNetwork}/${adunitCode}`;
                    }
                } else {
                    if (ishbNtwrkOverriden == true || hbAmp) {
                        return `${hbNetworkOverride ? hbNetworkOverride : current_dfp_network}/${adunitCode}`;
                    } else if (current_dfp_network) {
                        return `${current_dfp_network}/${adunitCode}`;
                    } else {
                        if (this.domainMcmEnabled) {
                            if (domainMcmType == 'MANAGE_ACCOUNT') {
                                return `${domainMcmChild}/${adunitCode}`;
                            } else {
                                return `${domainNetowrkCode},${domainMcmChild}/${adunitCode}`;
                            }
                        } else {
                            return `${domainNetowrkCode}/${adunitCode}`;
                        }
                    }
                }
            } else {
                if (hbAccountType) {
                    if (hbAccountType == 'MANAGE_ACCOUNT') {
                        return `${hbOverridenChildNetwork}/${domainParentCode}/${adunitCode}`;
                    } else {
                        // return `${domainNetowrkCode},${hbOverridenChildNetwork}/${domainParentCode}/${adunitCode}`
                        return `${current_dfp_network},${hbOverridenChildNetwork}/${domainParentCode}/${adunitCode}`;
                    }
                }
                if (ishbNtwrkOverriden == true || hbAmp) {
                    console.log('opopopop');
                    return `${
                        hbNetworkOverride ? hbNetworkOverride : domainNetowrkCode
                    }/${domainParentCode}/${adunitCode}`;
                } else if (current_dfp_network) {
                    return `${current_dfp_network}/${domainParentCode}/${adunitCode}`;
                } else {
                    if (this.domainMcmEnabled) {
                        if (domainMcmType == 'MANAGE_ACCOUNT') {
                            return `${domainMcmChild}/${domainParentCode}/${adunitCode}`;
                        } else {
                            return `${domainNetowrkCode},${domainMcmChild}/${domainParentCode}/${adunitCode}`;
                        }
                    } else {
                        return `${domainNetowrkCode}/${domainParentCode}/${adunitCode}`;
                    }
                }
            }

            return adunitCode;
        },
        getSizeForSearchDropdown() {
            console.log('is_amp', this.is_amp);
            var getSizes = BASE_URL + `v1/hb-ad-unit-size-list/domain/${this.domId}/`;
            var reqObj = {
                is_amp: this.is_amp,
            };
            axios.post(getSizes, reqObj).then((res) => {
                console.log('res getsize', res);
                this.allDimensionsSearch = res.data;
            });
        },
        clearSearch() {
            this.searchString = '';
            this.searchNetworkOverride = false;
            this.selectedNetworkCode = '';
            this.selectedChildDfpNetworkCode = '';
            this.initialize(1);
        },
        filterHbAdUnit() {
            this.currentPage = 1;
            console.log('sstring', this.searchString.length);

            this.issearch = true;
            this.initialize(this.currentPage);
        },
        handleCurrentChange(val) {
            console.log('search', this.issearch);
            console.log('search sstring', this.searchString.length);
            console.log('val');
            console.log(val);
            this.$route.query.page = val;
            if (this.searchString.length != 0) {
                this.issearch = true;
            }
            this.currentPage = val;
            this.initialize(val);
        },
        handleSizeChange(val) {
            //console.log("pages")
            this.offset = val;
            this.initialize(1);
            this.currentPage = 1;
        },
        OpenHbAdUnitsUsage(command) {
            console.log('command', command);
            setTimeout(() => {
                let url = `/admin/publisher/${this.$route.params.uuid}/domain/${this.domId}/buckets/${command.bucket_id}/fi/?adHbAdUnit=${command.hb_tag_id}`;
                console.log('command url', url);
                this.$router.push(url);
            });
        },

        filterDimension() {
            if (this.selectedDimensions.length != 0) {
                this.issearch = true;
            }
            this.initialize(1);
        },
        initialize(pageNum) {
            if (this.selectedDimensions.length != 0 || this.searchString.length != 0) {
                this.issearch = true;
            }

            console.log('Domain ID: ', this.$route.params.domId);
            this.hb_tags = [];
            let self = this;
            this.domId = this.$route.params.domId;
            this.pubUid = this.$route.params.uuid;
            this.loading = true;
            if (pageNum == undefined) {
                pageNum = 1;
            }

            var viewApi =
                BASE_URL +
                `v1/${this.is_amp ? 'amp_hb_tags' : 'hb_tags'}/${this.domId}/?page=${pageNum}&&offset=${this.offset}`;

            var searchApi =
                BASE_URL +
                `v1/${this.is_amp ? 'search-hb-amp-ad-unit' : 'search-hb-ad-unit'}/domain/${this.domId}/?query=${
                    this.searchString
                }&offset=${this.offset}&page=${this.currentPage}&` +
                'dimensionId=[' +
                this.selectedDimensions +
                ']' +
                '&dfp_network_code=' +
                this.selectedNetworkCode +
                '&child_dfp_network_code=' +
                this.selectedChildDfpNetworkCode +
                '&network_override=' +
                this.searchNetworkOverride;

            console.log(this);
            axios
                .all([
                    axios.get(this.issearch ? searchApi : viewApi),
                    axios.get(BASE_URL + 'v1/ad-dimensions/'),
                    axios.get(BASE_URL + 'v1/get-bidders-under-domain/' + this.domId),
                    axios.get(BASE_URL + `v1/publishers/${this.pubUid}/domains/${this.domId}/`),
                    axios.get(BASE_URL + 'v1/hb-tag-param-set/' + this.domId + '/'),
                    axios.get(BASE_URL + `v1/amp_hb_tags/${this.domId}/`),
                ])
                .then(
                    axios.spread((hb_tags, dimensions, bidders, domain, param_sets, all_amp_hb_tags) => {
                        this.issearch = false;

                        this.hb_tags = hb_tags.data.response_data.hb_tags;
                        console.log('hb_tags', domain);
                        this.bucketList = domain.data.data;
                        console.log('bucketList', this.bucketList);
                        // console.log("data", data.data.buckets[0].name)
                        console.log('hb_tags1', this.hb_tags);
                        this.all_amp_hb_tags = all_amp_hb_tags.data.response_data.hb_tags;
                        console.log(this.all_amp_hb_tags);
                        console.log('my1 hb_tags', this.hb_tags);
                        this.total_pages = hb_tags.data.response_data.total;
                        this.dimensions = dimensions.data;
                        this.bidders = bidders.data;
                        this.loading = false;
                        this.domain_details = domain.data;
                        this.buildPublisherInstructions();
                        this.param_sets = param_sets.data.data;

                        console.log('this.name', this.name);

                        for (var i = 0; i < this.hb_tags.length; i++) {
                            let tag_id = this.hb_tags[i].id;
                            this.bidderParamsForm.formData[tag_id] = {};
                            for (let j = 0; j < this.hb_tags[i].dimensions.length; j++) {
                                let dimension_str =
                                    this.hb_tags[i].dimensions[j]['width'] +
                                    'X' +
                                    this.hb_tags[i].dimensions[j]['height'];
                                this.bidderCopyParamsData[dimension_str] = {};
                                this.bidderParamsForm.formData[tag_id][dimension_str] = {};
                                this.bidderParamsForm.formData[tag_id][dimension_str]['param_set'] =
                                    this.hb_tags[i][dimension_str]['param_set'];
                            }
                        }
                        console.log(this.bidderParamsForm.formData);
                        this.bidderParamsForm2 = JSON.parse(JSON.stringify(this.bidderParamsForm));

                        console.log('form', this.bidderParamsForm.formData);
                        if (this.$route.query.tag_id) {
                            this.activeNames = this.getTagDetails(this.$route.query.tag_id)
                                ? this.getTagDetails(this.$route.query.tag_id).id
                                : '';
                            if (!this.getTagDetails(this.$route.query.tag_id)) {
                                console.log('Create HB tag entry!!');
                                // self.createHbTag(this.$route.query.tag_id);
                            }
                        }
                    })
                );
        },
        OpenAdSpotUsage(command) {
            setTimeout(() => {
                let url = `/admin/publisher/${this.uuid}/domain/${this.domId}/buckets/${command.bucket_id}/fi/?adSpotId=${command.id}`;
                console.log('command url', url);
                this.$router.push(url);
            });
        },
        copyAmpTag(hbTag) {
            console.log('@@copy amp hbTag', hbTag);
            let highestDimension = [hbTag.dimensions[0]['width'], hbTag.dimensions[0]['height']];
            let allSizes = hbTag.dimensions
                .map((dimen) => {
                    return dimen['width'] + 'x' + dimen['height'];
                })
                .join(',');
            console.log('Dimensions: ' + allSizes);

            hbTag.dimensions.forEach((dimen) => {
                if (
                    parseInt(dimen['height']) + parseInt(dimen['width']) >
                    parseInt(highestDimension[1]) + parseInt(highestDimension[0])
                ) {
                    highestDimension[0] = dimen['width'];
                    highestDimension[1] = dimen['height'];
                }
            });
            let code = hbTag.dfp_ad_unit_code.split('/');
            let name = code[code.length - 1];
            console.log(this.domain_details.uuid + '_' + name.trim());
            // let ntwrk_code = (hbTag.network_override) ? hbTag.network_override : this.domain_details.dfp_network.network_code
            // console.log('pppp',hbTag,hbTag.name)

            // if(hbTag.network_override){
            // 	if(hbTag.mcm_account_switch){
            // 		if(hbTag.mcm_account_switch=='MANAGE_INVENTORY'){
            // 			ntwrk_code= hbTag.network_override+','+hbTag.child_network_override
            // 			console.log('pppp',hbTag,hbTag.name)
            // 		}else if(hbTag.mcm_account_switch=='MANAGE_ACCOUNT'){
            // 			ntwrk_code= hbTag.child_network_override
            // 		}
            // 		else{
            // 			ntwrk_code= hbTag.network_override
            // 		}
            // 	}else if(this.domain_details.mcm_enable==true){
            // 		if(this.domain_details.mcm.account_type=='MANAGE_ACCOUNT'){
            // 			ntwrk_code= this.domain_details.child_dfp_network.child_network_code
            // 		}else if(this.domain_details.mcm.account_type=='MANAGE_INVENTORY'){
            // 			ntwrk_code= this.domain_details.dfp_network.network_code+','+this.domain_details.child_dfp_network.child_network_code
            // 		}else{
            // 			ntwrk_code= this.domain_details.dfp_network.network_code
            // 		}
            // 	}
            // }else{
            // 	 ntwrk_code= this.domain_details.dfp_network.network_code
            // }

            if (hbTag.is_amp_sticky) {
                ``;
                return `<amp-sticky-ad layout="nodisplay">
	<amp-ad width=${highestDimension[0]} height=${highestDimension[1]}
		type="doubleclick"
		data-slot="/${this.getAdunitPath(hbTag)}"
		data-multi-size="${allSizes}"
		    rtc-config='{"urls":["https://us-east-pbs.automatad.com/openrtb2/amp?tag_id=${
                this.domain_details.uuid
            }_${name.trim()}&curl=CANONICAL_URL"]}'
data-enable-refresh=30>
		</amp-ad>
</amp-sticky-ad>`.replace(/(https?:\/\/)|(\/)+/g, '$1$2');
            } else {
                return `<amp-ad width=${highestDimension[0]} height=${highestDimension[1]}
	type="doubleclick"
	data-slot="/${this.getAdunitPath(hbTag)}"
	data-multi-size="${allSizes}"
	    rtc-config='{"urls":["https://us-east-pbs.automatad.com/openrtb2/amp?tag_id=${
            this.domain_details.uuid
        }_${name.trim()}&curl=CANONICAL_URL"]}'
data-enable-refresh=30>
</amp-ad>

`.replace(/(https?:\/\/)|(\/)+/g, '$1$2');
            }
        },
        copyTagId(hbTag) {
            console.log('@@copy amp hbTag', hbTag);
            let highestDimension = [hbTag.dimensions[0]['width'], hbTag.dimensions[0]['height']];
            let allSizes = hbTag.dimensions
                .map((dimen) => {
                    return dimen['width'] + 'x' + dimen['height'];
                })
                .join(',');
            console.log('Dimensions: ' + allSizes);

            hbTag.dimensions.forEach((dimen) => {
                if (
                    parseInt(dimen['height']) + parseInt(dimen['width']) >
                    parseInt(highestDimension[1]) + parseInt(highestDimension[0])
                ) {
                    highestDimension[0] = dimen['width'];
                    highestDimension[1] = dimen['height'];
                }
            });
            let code = hbTag.dfp_ad_unit_code.split('/');
            let name = code[code.length - 1];
            let tagged_ID = this.domain_details.uuid + '_' + name.trim();
            return tagged_ID;
        },
        ampTagCopied() {
            this.$notify({
                title: 'Success',
                message: 'Successfully copied the AMP tag',
                type: 'success',
            });
        },
        tagIdCopied() {
            this.$notify({
                title: 'Success',
                message: 'Successfully copied the Tag ID',
                type: 'success',
            });
        },
        buildPublisherInstructions() {
            let tags = '';
            for (let i = 0; i < this.all_amp_hb_tags.length; i++) {
                tags += `\n\n\n${i + 1}) Position: ''

${this.copyAmpTag(this.all_amp_hb_tags[i])}`;
            }
            this.pubInstructions = this.pubInstructions + tags;
        },
        copyParamsAll(selectedDimension, bidderCode, id) {
            for (var param in this.bidderCopyParamsData[selectedDimension][bidderCode]) {
                this.bidderParamsForm.formData[id][selectedDimension][bidderCode][param] = JSON.parse(
                    JSON.stringify(this.bidderCopyParamsData[selectedDimension][bidderCode][param])
                );
            }

            this.$forceUpdate();
        },
        handleChange(val) {
            console.log(this.activeNames);
            if (this.activeNames == '') {
                console.log(this.prevActiveNames + ' was closed');
            }
            this.recentlyClosed = this.prevActiveNames;

            this.prevActiveNames = this.activeNames;
        },
        getDimension(dimensions) {
            console.log(dimensions);
            // return dimensions.map(function(dimension){
            // 	return dimension['width'] + 'X' + dimension['height'];
            // }).join(', ');
            let res = dimensions.map(function (dimension) {
                return dimension['width'] + 'X' + dimension['height'];
            });
            return res;
        },
        getDimensionInStr(dimension) {
            return dimension['width'] + 'X' + dimension['height'];
        },
        getBidderFields(bidder_id, hb_tag) {
            for (let i = 0; i < this.bidders.length; i++) {
                if (this.bidders[i].id == bidder_id) {
                    return JSON.parse(this.bidders[i].param);
                }
            }
        },

        setSelectedBidder(bidder_code, tag_id, dimension) {
            console.log(dimension);
            console.log('setSelectedBidder ran');
            if (!this.bidderParamsForm.formData[tag_id][dimension][bidder_code]) {
                console.log('SET defaults ');
            }
        },
        setSelectedOwnership(bidder_code, tag_id, val) {},
        updateHbTag(hb_tag, dim) {
            console.log(hb_tag);
            let hb_tag_id = hb_tag.id;
            this.loading = true;
            console.log(this.bidderParamsForm2.formData[hb_tag_id]);
            console.log(this.bidderParamsForm2.formData[hb_tag_id][`${dim.width}X${dim.height}`]);
            let dimId = dim.id;
            console.log(dimId);

            let requestObject = {
                hb_tag_id: hb_tag_id,
                dimension_id: dimId,
                param_set_id: this.bidderParamsForm2.formData[hb_tag_id][`${dim.width}X${dim.height}`]['param_set'],
            };

            axios
                .post(BASE_URL + 'v1/update_hb_tag/' + this.domId + '/', requestObject)
                .then((response) => {
                    console.log(response);
                    if (response.data.status == 'success') {
                        this.$notify({
                            title: 'Success',
                            message: 'Successfully updated the tag!!',
                            type: 'success',
                        });
                        this.loading = false;
                        this.recentlyClosed = this.activeNames;
                        if (!(hb_tag.dimensions.length > 1)) this.activeNames = '';
                    } else if (response.data.status == 'error') {
                        this.$notify({
                            title: 'Error',
                            message: response.data.reason,
                            type: 'error',
                        });
                        this.loading = false;
                        this.recentlyClosed = this.activeNames;
                        if (!(hb_tag.dimensions.length > 1)) this.activeNames = '';
                    }
                })
                .catch(function (error) {
                    console.log('Error:', error);
                    this.loading = false;
                });

            // let hb_tag = this.getTagDetails(hb_tag_id);
            // let dimId = null;
            // this.dimensions.forEach(function(dimension){
            // 	if(dimension['width'] + 'X' + dimension['height'] == dim) dimId = dimension.id;
            // });
            // console.log(dimId);
            // let tempParams = JSON.parse(JSON.stringify(this.bidderParamsForm.formData[hb_tag_id][dim]));
            // console.log(tempParams);

            // for (var bidders in tempParams) {
            // 	if(!this.bidderCopyParamsData[dim][bidders] && tempParams[bidders]['enabled']){
            // 		console.log('Object empty');
            // 		console.log(this.bidderParamsForm.formData[hb_tag_id][dim]);
            // 		this.bidderCopyParamsData[dim][bidders] = tempParams[bidders];
            // 	}
            // 	for (var params in tempParams[bidders]){
            // 		console.log(tempParams[bidders][params]);
            // 		if(tempParams[bidders][params].toString().trim() == '') delete tempParams[bidders][params];
            // 	}
            // }
            // let requestObject = {
            // 	'bidders': JSON.stringify(tempParams),
            // 	'hb_tag_id': hb_tag_id,
            // 	'dimension': dimId
            // }
            // console.log(tempParams);

            // axios.post(BASE_URL +'v1/update_hb_tag/'+ this.domId + '/', requestObject)
            // .then(response => {
            // 	console.log(response);
            // 	if(response.data.status == 'success'){
            // 		this.$notify({
            // 			title: 'Success',
            // 			message: 'Successfully updated the tag!!',
            // 			type: 'success'
            // 		});
            // 		this.recentlyClosed = this.activeNames;
            // 		this.activeNames = '';
            // 	}
            // 	else if(response.data.status == 'error'){
            // 		this.$notify({
            // 			title: 'Error',
            // 			message: response.data.reason,
            // 			type: 'error'
            // 		});
            // 		this.recentlyClosed = this.activeNames;
            // 		this.activeNames = '';
            // 	}
            // 	// this.$emit('update_logs')
            // 	// console.log(EventBus);
            // 	// EventBus.$emit('update_logs')
            // })
            // .catch(function (error) {
            // 	console.log('Error:', error);
            // });
        },
        getParamSetsForDim(dimId) {
            console.log(dimId);
            let res = this.param_sets.filter((param_set) => {
                if (this.is_amp) {
                    return param_set.dimension.id == dimId && param_set.is_amp;
                } else {
                    return param_set.dimension.id == dimId && !param_set.is_amp;
                }
                // return param_set.dimension.id == dimId
            });
            console.log(res);
            return res;
        },
        getTagDetails(tag_id) {
            for (let i = 0; i < this.hb_tags.length; i++) {
                if (this.hb_tags[i].id == tag_id) {
                    return this.hb_tags[i];
                }
            }
        },
    },
};
</script>




// WEBPACK FOOTER //
// HbTagParamsNew.vue?124c5c11